import { createSlice } from "@reduxjs/toolkit";
import { spaceProductsDelete } from "./spaceProductsAsyncThunk";

const spaceProductDeleteSlice = createSlice({
  name: "spaceProduct",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [spaceProductsDelete.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [spaceProductsDelete.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [spaceProductsDelete.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isFail = true;
    },
  },
});

export default spaceProductDeleteSlice.reducer;
